const $ = jQuery.noConflict();
function scrollFunc(e) {
	let target;

	if ('string' === typeof e) {
		target = $(e);
	} else {
		e.preventDefault();
		target = $($(this).attr('href'));
	}

	let headerHeight = 60;

	if (window.innerWidth >= 992) {
		headerHeight = 84;
	}

	if (document.body.classList.contains('has-quick-links')) {
		headerHeight = 72;
	}

	if (
		target.hasClass('block-hook') &&
		target.parent().hasClass('acf-block')
	) {
		target = target.parent();
	}

	if (target.length) {
		const topPadding = parseInt(target.css('padding-top'));
		let previousBlockBottomPadding = 0;
		let additionalOffset = 0;

		if (0 === topPadding && !target.hasClass('block-hook')) {
			previousBlockBottomPadding = parseInt(
				$(target).prev().css('padding-bottom')
			);

			if (0 === previousBlockBottomPadding) {
				additionalOffset = 64;
			} else {
				additionalOffset = previousBlockBottomPadding;
			}
		}

		additionalOffset =
			additionalOffset !== additionalOffset ? 64 : additionalOffset;
		$('html, body').animate(
			{
				scrollTop:
					target.offset().top - headerHeight - additionalOffset,
			},
			1000
		);
	}
}
function smoothScroll() {
	$('a[href^="#"]:not([href="#"])').off('click', scrollFunc);
	$('a[href^="#"]:not([href="#"])').on('click', scrollFunc);
}

function pageLoadSmoothScroll() {
	if (window.location.hash) {
		const hash = window.location.hash;
		window.location.hash = '';
		window.location._hash = hash;

		setTimeout(() => {
			scrollFunc(hash);
			window.location.hash = hash;
		}, 1);
	}
}

window.addEventListener('aifsapi-data-changed', smoothScroll);

export { smoothScroll, pageLoadSmoothScroll };
